import React from 'react'
import PropTypes from 'prop-types'
import { SVGIcon } from 'components/qstrap'
import triggerEvent from 'utils/dataLayer'

const ItemSubjects = ({ studyFields }) => (
  <div className="faculty-subjects">
    {studyFields.map((subject, index) => (
      <div key={index} className="faculty-subjects__item">
        {subject}
      </div>
    ))}

    <style jsx>
      {`
        .faculty-subjects {
          display: flex;
          flex-wrap: wrap;
      
          &__item {
            position: relative;
            padding-right: 18px;
            color: #7d92a9;
            line-height: 1.71em;

            &:last-child {
              &::before {
                content: none;
              }
            }
      
            &::before {
              content: '\\B7';
              position: absolute;
              font-size: 30px;
              right: 5px;
            }
          }
        }
      `}
    </style>
  </div>
)

ItemSubjects.propTypes = {
  studyFields: PropTypes.array,
}

const FacultyItem = ({
  path,
  name,
  static_majors: staticMajors,
  study_fields: studyFields,
}) => {
  const subjects = staticMajors.length > 0 ? staticMajors : studyFields
  return (
    <a href={path} className="faculty-item" onClick={() => triggerEvent(`ga/campus/card-faculty/${name}`)}>
      <div className="faculty-item__content">
        <h6 className="faculty-item__name m-b">{name}</h6>
        { subjects.length > 0 && <ItemSubjects studyFields={subjects} />}
      </div>
      <div className="faculty-item__icon">
        <SVGIcon name="next" />
      </div>
      <style jsx>
        {`
          .faculty-item {
            display: block;
            position: relative;
            background: #fff;
            border: 1px solid #dce4eb;
            padding: 1em;
            border-radius: 4px;
            margin-bottom: 7px;
            cursor: pointer;
            color: unset;
            text-decoration: unset;
            &__icon {
              position: absolute;
              top: 1em;
              right: 1em;
              color: #a3b4ca;
            }
          }
        `}
      </style>
    </a>
  )
}

FacultyItem.propTypes = {
  path: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  study_fields: PropTypes.array,
  static_majors: PropTypes.array,
}

FacultyItem.defaultProps = {
  static_majors: [],
  study_fields: [],
}

export default FacultyItem
